

import React, { useState } from 'react';
import './Login.css';
import { FaArrowLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleLogin = () => {
    console.log('Username:', username);
    console.log('Password:', password);
    console.log('Remember Me:', rememberMe);
  };

  return (
    <div className='log'>
    <div className="login-container">
        <div className='fcontainer'>
         <div className="top-left-container2">
        <Link to="/" className="top-left-btn">
          <FaArrowLeft />
        </Link>
        
      </div>
      </div>
      <h2>Login</h2>
      <div className="input-container">
        <label>Username:</label>
        <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
      </div>
      <div className="input-container">
        <label>Password:</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      </div>
      <div className="checkbox-container">
        <div className='check'>
          <input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
          <label>Remember me</label>
        </div>
        <a href="#" className="forgot-password">Forgot password?</a>
      </div>
      <button onClick={handleLogin} className='login'>Login</button>
      </div>
    </div>
  );
}

export default Login;
